export enum UserBlocker {
    /**
     * The user has not accepted the terms of service and has no circle
     */
    Tos = 'tos',
    /**
     * The user is not a sponsored user
     */
    Unsponsored = 'unsponsored',
    /**
     * The user needs to link their SSO account
     */
    LinkingSSO = 'linkingSSO',
    /**
     * The user arrived via a magic link with access_code and sponsor_code
     */
    AutoSubmitMagicLink = 'autoSubmitMagicLink',
    /**
     * A first-time user has an invitation that they might redeem
     */
    ReceivingInvitation = 'receivingInvitation',
    /**
     * Used to determine if an unsponsored user needs to report their permanent residence
     */
    CountryUnsponsored = 'countryUnsponsored',
    /**
     * Used to determine if an unsponsored user needs to report their permanent residence but also has an access code
     */
    CountryUnsponsoredHasAccessCode = 'countryUnsponsoredHasAccessCode',
    /**
     * Used to determine if a sponsored user needs to report their permanent residence
     */
    CountrySponsored = 'countrySponsored',
    /**
     * Used to determine if the user needs to report their permanent residence
     */
    CommunicationsPreference = 'communicationsPreference',
    /**
     * Used to determine if the user needs to accept CCHD
     */
    CCHDUnsponsored = 'cchdUnsponsored',
    /**
     * Used to determine if the user needs to accept CCHD after sponsorship
     */
    CCHDSponsored = 'cchdSponsored',
    /**
     * Used to determine if the user needs to accept UK after sponsorship
     */
    UK = 'uk',
    /**
     * Used to determine if the user needs to accept India after sponsorship
     */
    India = 'india',
    /**
     * Used to determine if the user needs to accept China after sponsorship
     */
    China = 'china',
    /**
     * Used to determine if the user needs to accept EU after sponsorship
     */
    EU = 'EU',
    /**
     * Used to determine if the user needs to accept Australia after sponsorship
     */
    Australia = 'australia',
    /**
     * Used to determine if the user needs to accept International after sponsorship
     */
    International = 'international',
    /**
     * Used to determine if the user needs to reconsent to TOS/Privacy, CHDPP, or Partner Authorization
     */
    Reconsent = 'reconsent',
    /**
     * Used to determine if the user should be brought to the loss of sponsorship flow
     */
    Expired = 'expired',
    /**
     * The user is not a sponsored user
     */
    PostMentalHealthScreeningPromo = 'postMentalHealthScreeningPromo',
    /**
     * Used to determine if the user needs to add Age/Gender after registration
     */
    RegistrationAgeGender = 'registrationAgeGender',
    /**
     * The user is a minor and requires parental consent - via the registration flow
     */
    RegistrationParentalConsent = 'registrationParentalConsent',
    /**
     * The user is a minor and requires parental consent - via the profile page dialog
     */
    StandaloneParentalConsent = 'StandaloneParentalConsent',
    /**
     * The user needs to complete the FTUE workflow
     */
    Onboarding = 'onboarding',
    /**
     * The user needs to complete the FTUE workflow
     */
    ConciergeOnboarding = 'ConciergeOnboarding',
}
